import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/layout'
import layoutIndustry from '@/layoutIndustry/layout'
import layoutKejiaohui from '@/layoutKejiaohui/layout'
import layoutPark from '@/layoutPark/layout'
import layoutCollege from '@/layoutCollege/layout'
import layoutCollegeAll from '@/layoutCollegeAll/layout'
import layoutCollegePatent from '@/layoutCollegePatent/layout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*', redirect: '/enterprise'
    },

    {
      path: '/enterprise/login',
      name: 'enterpriseLogin',
      meta:{
      },
      component: () => import('@/pages/enterprise/login/index'),
    },
    {
      path: '/park/login',
      name: 'parkLogin',
      meta:{
      },
      component: () => import('@/pages/park/login/index'),
    },
    {
      path: '/college/login',
      name: 'collegeLogin',
      meta:{
      },
      component: () => import('@/pages/college/login/index'),
    },
    // 企业
    {
      path: '/enterprise',
      component: layout,
      redirect: '/enterprise/EnterpriseStatisticalAnalysis',
      meta: {
        title: '首页',
        isLogin:true
      },
      children: [
        {
          // 专利统计分析
          path: '/enterprise/PatentStatisticalAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/PatentStatisticalAnalysis',
          children: [
            {
              path: '/enterprise/PatentStatisticalAnalysis',
              name: 'enterprisePatentValueAnalysis',
              component: () => import('@/pages/enterprise/PatentStatisticalAnalysis/detail'),
            }
            // {
            //   path: '/enterprise/PatentStatisticalAnalysis',
            //   name: 'enterprisePatentStatisticalAnalysis',
            //   component: () => import('@/pages/enterprise/PatentStatisticalAnalysis/index'),
            // },
            // {
            //   // 供给侧、需求侧  type:demand、supply
            //   path: '/enterprise/PatentStatisticalAnalysis/:type?',
            //   name: 'enterprisePatentStatisticalAnalysisDetail',
            //   component: () => import('@/pages/enterprise/PatentStatisticalAnalysis/detail'),
            // },
          ]
        },
        {
          // 专利统计分析
          path: '/enterprise/PatentValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/PatentValueAnalysis',
          children: [
            {
              path: '/enterprise/PatentValueAnalysis',
              name: 'enterprisePatentValueAnalysis',
              component: () => import('@/pages/enterprise/PatentValueAnalysis/index'),
            },
            {
              path: '/enterprise/PatentValueAnalysis/list',
              name: 'enterprisePatentList',
              component: () => import('@/pages/enterprise/PatentValueAnalysis/list'),
            },
            {
              path: '/enterprise/PatentValueAnalysis/PatentListOnly/:ano?/:publicationNumber?',
              name: 'enterprisePatentListOnly',
              component: () => import('@/pages/enterprise/PatentValueAnalysis/only'),
            },
          ]
        },
        {
          // 运营分析
          path: '/enterprise/OperationAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/operationAnalysis',
          children: [
            {
              path: '/enterprise/operationAnalysis',
              name: 'enterpriseoperationAnalysis',
              component: () => import('@/pages/enterprise/OperationAnalysis/index'),
            },
            {
              path: '/enterprise/operationAnalysis/auction',
              name: 'enterpriseauction',
              component: () => import('@/pages/enterprise/OperationAnalysis/auction'),
            }, {
              path: '/enterprise/operationAnalysis/challenge',
              name: 'enterprisechallenge',
              component: () => import('@/pages/enterprise/OperationAnalysis/challenge'),
            },
          ]
        },
        {
          // 企业统计分析
          path: '/enterprise/EnterpriseStatisticalAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/EnterpriseStatisticalAnalysis',
          children: [
            {
              path: '/enterprise/EnterpriseStatisticalAnalysis',
              name: 'enterprisegeneral',
              component: () => import('@/pages/enterprise/EnterpriseStatisticalAnalysis/index'),
            },
            {
              path: '/enterprise/EnterpriseStatisticalAnalysis/enterprise',
              name: 'enterpriseoverview',
              component: () => import('@/pages/enterprise/EnterpriseStatisticalAnalysis/enterprise'),
            },
            {
              path: '/enterprise/EnterpriseStatisticalAnalysis/overview',
              name: 'enterpriseoverview',
              component: () => import('@/pages/enterprise/EnterpriseStatisticalAnalysis/overview'),
            }
          ]
        },
        {
          // 企业价值分析
          path: '/enterprise/EnterpriseValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/EnterpriseValueAnalysis',
          children: [
            {
              path: '/enterprise/EnterpriseValueAnalysis',
              name: 'enterpriseEnterpriseValueAnalysis',
              component: () => import('@/pages/enterprise/EnterpriseValueAnalysis/index'),
            },
            {
              path: '/enterprise/EnterpriseValueAnalysis/list',
              name: 'enterpriseEnterpriseValueAnalysisList',
              component: () => import('@/pages/enterprise/EnterpriseValueAnalysis/list'),
            },
            {
              path: '/enterprise/EnterpriseValueAnalysis/info',
              name: 'enterpriseEnterpriseValueAnalysisInfo',
              component: () => import('@/pages/enterprise/EnterpriseValueAnalysis/info'),
            },
            {
              path: '/enterprise/EnterpriseValueAnalysis/annualReport',
              name: 'enterpriseEnterpriseValueAnalysisAnnualReport',
              component: () => import('@/pages/enterprise/EnterpriseValueAnalysis/annualReport'),
            }
          ]
        },
        {
          // 分类管理
          path: '/enterprise/ClassificationManagement',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/enterprise/ClassificationManagement',
          children: [
            {
              path: '/enterprise/ClassificationManagement',
              name: 'enterpriseClassificationManagement',
              component: () => import('@/pages/enterprise/ClassificationManagement/index'),
            },
          ]
        },
        {
          path: '/enterprise/operationAnalysisTwo',
          name: 'enterpriseoperationAnalysisTwo',
          component: () => import('@/pages/enterprise/operationAnalysisTwo/index'),
          meta: {headerNotShow: true},
        },
        {
          path: '/enterprise/operationAnalysisTwo/auction',
          name: 'enterpriseauctionTwo',
          component: () => import('@/pages/enterprise/operationAnalysisTwo/auction'),
          meta: {headerNotShow: true},
        }, {
          path: '/enterprise/operationAnalysisTwo/challenge',
          name: 'enterprisechallengeTwo',
          component: () => import('@/pages/enterprise/operationAnalysisTwo/challenge'),
          meta: {headerNotShow: true},
        }
      ]
    },
    // 园区
    {
      path: '/park',
      component: layoutPark,
      redirect: '/park/EnterpriseStatisticalAnalysis',
      meta: {
        title: '首页',
        isLogin:true
      },
      children: [
        {
          // 专利统计分析
          path: '/park/PatentStatisticalAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/park/PatentStatisticalAnalysis',
          children: [
            {
              path: '/park/PatentStatisticalAnalysis',
              name: '/parkPatentStatisticalAnalysisDetail',
              component: () => import('@/pages/park/PatentStatisticalAnalysis/detail'),
            },
          ]
        },
        {
          // 专利统计分析
          path: '/park/PatentValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/park/PatentValueAnalysis/list',
          children: [
            {
              path: '/park/PatentValueAnalysis/list',
              name: 'parkPatentList',
              component: () => import('@/pages/park/PatentValueAnalysis/list'),
            },
            {
              path: '/park/PatentValueAnalysis/PatentListOnly/:ano?/:publicationNumber?',
              name: 'parkPatentListOnly',
              component: () => import('@/pages/park/PatentValueAnalysis/only'),
            },
          ]
        },
        {
          // 园区企业分析
          path: '/park/EnterpriseStatisticalAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/park/EnterpriseStatisticalAnalysis',
          children: [
            {
              path: '/park/EnterpriseStatisticalAnalysis',
              name: 'parkgeneral',
              component: () => import('@/pages/park/EnterpriseStatisticalAnalysis/index'),
            },
            {
              path: '/park/EnterpriseStatisticalAnalysis/overview',
              name: 'parkoverview',
              component: () => import('@/pages/park/EnterpriseStatisticalAnalysis/overview'),
            }
          ]
        },
        {
          // 企业价值分析
          path: '/park/EnterpriseValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/park/EnterpriseValueAnalysis/list',
          children: [
            {
              path: '/park/EnterpriseValueAnalysis/list',
              name: 'parkEnterpriseValueAnalysisList',
              component: () => import('@/pages/park/EnterpriseValueAnalysis/list'),
            },
            {
              path: '/park/EnterpriseValueAnalysis/info',
              name: 'parkEnterpriseValueAnalysisInfo',
              component: () => import('@/pages/park/EnterpriseValueAnalysis/info'),
            },
            {
              path: '/park/EnterpriseValueAnalysis/annualReport',
              name: 'parkEnterpriseValueAnalysisAnnualReport',
              component: () => import('@/pages/park/EnterpriseValueAnalysis/annualReport'),
            }
          ]
        }
      ]
    },
    //临时
    // {
    //   path: '/clinshi',
    //   name: 'clinshi',
    //   meta:{
    //   },
    //   component: () => import('@/pages/college/linshi/jishu/index.vue'),
    // },
    // {
    //   path: '/clinshi1',
    //   name: 'clinshi1',
    //   meta:{
    //   },
    //   component: () => import('@/pages/college/linshi/home/index.vue'),
    // },
    // {
    //   path: '/clinshi2',
    //   name: 'detail',
    //   meta:{
    //   },
    //   component: () => import('@/pages/college/linshi/jishu/detail.vue'),
    // },
    // 科交会
    {
      path: '/kejiaohui',
      component: layoutKejiaohui,
      redirect: '/kejiaohui/home',
      meta: {
        title: '首页',
        isLogin:true
      },
      children: [
        {
          //主屏
          path: '/kejiaohui/home',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/kejiaohui/home/index',
          children: [
            {
              path: '/kejiaohui/home/index',
              name: 'kejiaohuiHomeIndex',
              component: () => import('@/pages/kejiaohui/home/index')
            }
          ]
        },
        {
          // 成果统计分析
          path: '/kejiaohui/AchievementValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/kejiaohui/AchievementValueAnalysis',
          children: [
            {
              path: '/kejiaohui/AchievementValueAnalysis',
              name: 'kejiaohuiAchievementValueAnalysisIndex',
              component: () => import('@/pages/kejiaohui/AchievementValueAnalysis/index')
            },
            {
              path: '/kejiaohui/AchievementValueAnalysis/list',
              name: 'kejiaohuiAchievementValueAnalysisList',
              component: () => import('@/pages/kejiaohui/AchievementValueAnalysis/list')
            },
          ]
        },
        {
          // 需求统计分析
          path: '/kejiaohui/DemandValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/kejiaohui/DemandValueAnalysis',
          children: [
            {
              path: '/kejiaohui/DemandValueAnalysis',
              name: 'kejiaohuiDemandValueAnalysisIndex',
              component: () => import('@/pages/kejiaohui/DemandValueAnalysis/index')
            },
            {
              path: '/kejiaohui/DemandValueAnalysis/list',
              name: 'kejiaohuiDemandValueAnalysisList',
              component: () => import('@/pages/kejiaohui/DemandValueAnalysis/list')
            },
          ]
        }
      ]
    },
    // 高校
    {
      path: '/college',
      component: layoutCollege,
      redirect: '/college/PatentStatisticalAnalysis',
      meta: {
        title: '首页',
        isLogin:true
      },
      children: [

        {
          // 专利统计分析
          path: '/college/PatentStatisticalAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/college/PatentStatisticalAnalysis',
          children: [
            {
              path: '/college/PatentStatisticalAnalysis',
              name: 'collegePatentStatisticalAnalysisDetail',
              component: () => import('@/pages/college/PatentStatisticalAnalysis/detail')
            },
          ]
        }
      ]
    },
    {
      path:'/collegepatent',
      component:layoutCollegePatent,
      redirect:'/collegepatent/list',
      children: [{
        path: '/collegepatent/list',
        name: 'collegepatentlist',
        component: () => import('@/pages/allcollege/patent/listbycollege.vue')
      },
        {
          path: '/collegepatent/patent/PatentListOnly/:ano?/:publicationNumber?',
          name: 'collegepatentOnly',
          component: () => import('@/pages/allcollege/patent/only'),
        },]
    },
    // 全国 高校
    {
      path: '/allcollege',
      component: layoutCollegeAll,
      redirect: '/allcollege/echartsMap',
      meta: {
        title: '首页',
        isLogin:true
      },
      children: [
        {
          // 专利统计分析
          path: '/allcollege/echartsMap',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/allcollege/echartsMap',
          children: [
            {
              path: '/allcollege/echartsMap',
              name: 'allCollegeEchartsMapIndex',
              component: () => import('@/pages/allcollege/echartsMap/index')
            },
          ]
        },
        {
          // zhuali
          path: '/allcollege/patent',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/allcollege/patent',
          children: [
            {
              path: '/allcollege/patent',
              name: 'allcollegePatent',
              component: () => import('@/pages/allcollege/patent/index'),
            },
            {
              path: '/allcollege/patent/list',
              name: 'allcollegePatentList',
              component: () => import('@/pages/allcollege/patent/list'),
            },
            {
              path: '/allcollege/patent/PatentListOnly/:ano?/:publicationNumber?',
              name: 'allcollegePatentListOnly',
              component: () => import('@/pages/allcollege/patent/only'),
            },
          ]
        },
        {
          // 企业价值分析
          path: '/kejiaohui/EnterpriseValueAnalysis',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          redirect: '/kejiaohui/EnterpriseValueAnalysis',
          children: [
            {
              path: '/kejiaohui/EnterpriseValueAnalysis',
              name: 'kejiaohuiEnterpriseValueAnalysis',
              component: () => import('@/pages/kejiaohui/EnterpriseValueAnalysis/index'),
            },
            {
              path: '/kejiaohui/EnterpriseValueAnalysis/list',
              name: 'kejiaohuiEnterpriseValueAnalysisList',
              component: () => import('@/pages/kejiaohui/EnterpriseValueAnalysis/list'),
            },
            {
              path: '/kejiaohui/EnterpriseValueAnalysis/info',
              name: 'kejiaohuiEnterpriseValueAnalysisInfo',
              component: () => import('@/pages/kejiaohui/EnterpriseValueAnalysis/info'),
            },
            {
              path: '/kejiaohui/EnterpriseValueAnalysis/annualReport',
              name: 'kejiaohui',
              component: () => import('@/pages/kejiaohui/EnterpriseValueAnalysis/annualReport'),
            }
          ]
        },
        {
          path: '/kejiaohui/PatentStatisticalAnalysis',
          name: 'kejiaohuiPatentStatisticalAnalysisDetail',
          component: () => import('@/pages/kejiaohui/PatentStatisticalAnalysis/detail')
        },

      ]
    },
    {
      path: '/exportPDF/EER',
      name: 'enterpriseEvaluationReport',
      component: () => import('@/pages/exportPDF/enterpriseEvaluationReport'),
      meta: {isLogin: true},
    },
    {
      path: '/exportPDF/PER',
      name: 'patentEvaluationReport',
      component: () => import('@/pages/exportPDF/patentEvaluationReport'),
      meta: {isLogin: true},
    },
    {
      path: '/demoShow',
      name: 'DemoShow',
      component: () => import('@/pages/demoShow/DemoShow'),
      meta: {isLogin: false,title:'...'},
    },
    {
      // 分类管理
      path: '/industry',
      component: layoutIndustry,
      meta: {
        title: '首页',
        isLogin:true
      },
      redirect: '/industry/ClassificationManagement',
      children: [
        {
          path: '/industry/ClassificationManagement',
          name: 'industryClassificationManagement',
          component: () => import('@/pages/industry/ClassificationManagement/index'),
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js